import React, { useEffect, useState } from "react";
// import { useForm } from "../../shared/useForm";
import { useHistory } from "react-router-dom";
import { get, handleError } from "../../shared/HttpReq";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Auth from "../../auth/Auth";
import Spinner from "../../shared/spinner/Spinner";
import { Toast } from "../../shared/toaster/Toaster";
import moment from "moment";

function UserDetails() {
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });
  // const [error, setError] = useState(false);
  const [excursionCount, setExcursionCount] = useState([]);
  const [bookingId, setBookingId] = useState("");
  const [formValue, setFormValue] = useState([]);
  const [checked, setChecked] = useState({});

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const route = useHistory();
  let query = useQuery();

  // const {
  //   values = [],
  //   errors,
  //   bindField,
  // } = useForm({
  //   validations: {
  //     email: {
  //       pattern: {
  //         value:
  //           /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  //         message: "Invalid email address.",
  //       },
  //       required: {},
  //     },
  //     name: {
  //       required: {},
  //     },
  //   },
  // });
  //get user details

  const getCardDetail = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/booking-detail/${query.get(
          "token"
        )}`,
        await get()
      )
    );
    if (res.status >= 200 && res.status <= 299) {
      setLoading(false);
      setExcursionCount(res.data);
      setBookingId(res._id);
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.message,
      });
    }
  };
  /**
   * This function used  for checking duplicate email exist in same excursion booking.
   * @param { Array } intialvalues
   * @param { Number } bookingIndex
   * @param { String } type
   * @param { Event } event
   * @returns {undefined}
   */
  // const checkDuplicateEmail = (intialvalues, bookingIndex, type, event) => {
  //   if (['adult', 'senior'].indexOf(type) > -1) {
  //     const emailArray = intialvalues[bookingIndex].category.flatMap(category => category.users.filter(user => user.email)).map(user => user.email);
  //     if (emailArray.indexOf(event.target.value) > -1) {
  //       setError(!error);
  //     } else {
  //       setError(!error);
  //     }
  //   }
  // }

  const handleValues = (e, type, bookingId) => {
    e.preventDefault();
    setFormValue((prev) => {
      const index = e.target.id.split(`_${e.target.name}_`)[1];
      const intialvalues = [...prev];
      let bookingIndex = intialvalues?.findIndex(
        (v) => v.bookingId === bookingId
      );

      const ticketInfo = intialvalues[bookingIndex]?.category;
      if (ticketInfo) {
        const matched = ticketInfo.findIndex((item) => item.type === type);
        // Email validation;
        // e.target.name === 'email' && checkDuplicateEmail(intialvalues, bookingIndex, type, e);

        if (matched < 0) {
          intialvalues[bookingIndex].category = [
            ...intialvalues[bookingIndex].category,
            { type, users: [{ [e.target.name]: e.target.value }] },
          ];
          return intialvalues;
        }
        intialvalues[bookingIndex].category[matched].users[index] = {
          ...intialvalues[bookingIndex].category[matched].users[index],
          [e.target.name]: e.target.value,
        };

        // if (e.target.type === "checkbox") {
        //   // Handle checkbox state
        //   const isChecked = e.target.checked;
        //   console.log("inside");
        //   setChecked((prev) => ({ ...prev, [e.target.id]: isChecked }));
        //   intialvalues[bookingIndex].category[matched].users[index] = {
        //     ...intialvalues[bookingIndex].category[matched].users[index],
        //     [e.target.name]: isChecked,
        //   };
        // } else {
        //   // Handle other input fields
        //   intialvalues[bookingIndex].category[matched].users[index] = {
        //     ...intialvalues[bookingIndex].category[matched].users[index],
        //     [e.target.name]: e.target.value,
        //   };
        // }

        return intialvalues;
      }
      return [
        ...prev,
        {
          bookingId,
          category: [{ type, users: [{ [e.target.name]: e.target.value }] }],
        },
      ];
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    for (const key of Object.keys(checked)) {
      const [bookingId, index] = key.split(`_isVerified_`);
      let bookingIndex = formValue?.findIndex((v) => v.bookingId === bookingId);
      const ticketInfo = formValue[bookingIndex]?.category;
      console.log({ ticketInfo });
      const matched = ticketInfo.findIndex((item) => item.type === "child");
      formValue[bookingIndex].category[matched].users[index].isVerified =
        checked[key];
    }
    
    const data = await formValue.map((item) => {
      const users = item.category.flatMap((category) =>
        category.users.map((user) => ({ ...user, type: category.type }))
      );

      return {
        bookingId: item.bookingId,
        user: users,
      };
    });

    const res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/booking/user-details/${bookingId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ booking: data }),
        }
      )
    );
    if (res.status === 200) {
      setLoading(false);
      SetToaster(
        {
          show: true,
          type: "success", // type should be "danger" or "success"
          content: res.message,
        },
        2000
      );
      setTimeout(() => {
        route.push(`/?id=${Auth.getCompanyHexaID()}`);
      }, [2000]);
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.message,
      });
    }
  };

  const handleCheck = () => {};

  const appendRows = (type, count, bookingId) => {
    const element = [];
    for (let i = 0; i < count; i++) {
      element.push(
        <div className="row">
          <div className="col-lg-2 d-flex align-items-center">
            <h4
              className={`date_for_user ${
                type === "child" ? "for_type_child" : "for_type"
              }`}
            >
              For {type}s
            </h4>
          </div>
          <div className={`${type === "child" ? "col-lg-3" : "col-lg-4"}`}>
            <div className="input_field">
              <label htmlFor="#">Name</label>
              <input
                type="text"
                // name={`name${type}${i}`}
                name="name"
                // value={}
                id={`${bookingId}_name_${i}`}
                // {...bindField(`name${type}${i}`)}
                // ref={phoneElm}
                onChange={(e) => handleValues(e, type, bookingId)}
                className="input-txt"
                placeholder="Enter name"
                required
              />
              {/* {errors.phone && <p className="text-danger">{errors.phone}</p>} */}
            </div>
          </div>
          {type === "child" ? (
            <div className="col-lg-2">
              <input
                type="checkbox"
                className="checkbox_child"
                name="isVerified"
                id={`${bookingId}_isVerified_${i}`}
                // checked={
                //   checked[`${bookingId}_isVerified_${i}`] &&
                //   as(`${bookingId}_isVerified_${i}`, "isVerified")
                // }
                // // checked={
                // //   formValue.length > 0
                // //     ? as(`${bookingId}_isVerified_${i}`, "isVerified")
                // //     : false
                // // }
                onChange={(e) => {
                  setChecked((prev) => ({
                    ...prev,
                    [e.target.id]: e.target.checked,
                  }));
                }}
                // onChange={(e) => handleValues(e, type, bookingId)}
              />
            </div>
          ) : (
            ""
          )}
          {type !== "child" && (
            <div className="col-lg-4">
              <div className="input_field">
                <label htmlFor="#">Email</label>
                <input
                  type="email"
                  // id="login_email"
                  id={`${bookingId}_email_${i}`}
                  name="email"
                  // name={`email${type}${i}`}
                  onChange={(e) => handleValues(e, type, bookingId)}
                  // {...bindField(`email${type}${i}`)}
                  className="input-txt"
                  placeholder="Enter email"
                  required
                />
                {/* {errors.email && <p className="text-danger">{errors.email}</p>} */}
              </div>
            </div>
          )}
        </div>
      );
    }
    return element;
  };

  console.log("user details", excursionCount.bookedTo, { checked, formValue });

  // function as(id, name) {
  //   const [bookingId, index] = id.split(`_${name}_`);
  //   let bookingIndex = formValue?.findIndex((v) => v.bookingId === bookingId);

  //   const ticketInfo = formValue[bookingIndex]?.category;
  //   console.log({ ticketInfo });
  //   const matched = ticketInfo.findIndex((item) => item.type === "child");
  //   return formValue[bookingIndex].category[matched].users[index].isVerified
  //     ? true
  //     : false;
  // }
  useEffect(() => {
    query.get("token") && getCardDetail();
  }, [query.get("token")]);

  useEffect(() => {
    console.log("sdsdsd");
  }, [checked]);

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />

      <div className="pt-0">
        <div className="container">
          <div className="card_details_heading_top">
            <h4 className="everyday_color">Share User Details</h4>
          </div>
          <div className="adventure_booking_details pt-0">
            <form onSubmit={submitHandler}>
              {excursionCount.map((item) => (
                <div className="excursion_section">
                  <h4 className="everyday_color mb-3">{item.name}</h4>
                  <div className="d-flex align-items-center">
                    <p className="date_for_user">Date : </p>{" "}
                    <p className="date_or_time_for_user ml-2">
                      {moment(Date.parse(item.bookedTo.split("T")[0])).format(
                        "MMM Do YYYY"
                      )}{" "}
                      at {item.time}
                    </p>
                  </div>

                  {item.ticketInfo.map((ticket) => (
                    <div className="adults mt-4">
                      {/* {ticket.count > 0 && (
                        <h4 className={`date_for_user ${ticket.type === "child" ? "for_type_child" : "for_type"}`}>
                          For {ticket.type}s
                        </h4>
                      )} */}

                      {appendRows(ticket.type, ticket.count, item._id)}
                    </div>
                  ))}
                </div>
              ))}
              {/* {error === false ? '' : <p className="text-danger">Same Email is not allowed</p>} */}
              <div className="login_submit user_details mt-5">
                <button type="submit" className="active blue-bg">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserDetails;
